// "Conditions of Use" / "Privacy Notice" links, keyed by store country — see "Legal links" in AGENTS.md.

export type LegalLink = 'conditionsOfUse' | 'privacyNotice'

export type LegalCountry = 'US' | 'GB' | 'AU'

export const DEFAULT_LEGAL_COUNTRY: LegalCountry = 'US'

const LEGAL_SITE_BY_COUNTRY: Readonly<Record<LegalCountry, string>> = {
    US: 'www.amazon.com',
    GB: 'www.amazon.co.uk',
    AU: 'www.amazon.com.au',
}

/** Help-page node of each legal page; the same on every Amazon site. */
const NODE_ID_BY_LINK: Readonly<Record<LegalLink, string>> = {
    conditionsOfUse: 'GLSBYFE9MGKKQXXM',
    privacyNotice: 'GX7NJQ4ZB8MHFRNJ',
}

export const resolveLegalCountry = (countryCode?: string): LegalCountry => {
    const country = countryCode?.trim().toUpperCase() ?? ''
    return Object.prototype.hasOwnProperty.call(LEGAL_SITE_BY_COUNTRY, country)
        ? (country as LegalCountry)
        : DEFAULT_LEGAL_COUNTRY
}

export const getLegalLinkUrl = (link: LegalLink, countryCode?: string): string =>
    `https://${LEGAL_SITE_BY_COUNTRY[resolveLegalCountry(countryCode)]}/gp/help/customer/display.html?nodeId=${NODE_ID_BY_LINK[link]}`

interface INativeBridge {
    postMessage: (message: string) => void
}

/** The app's message bridge, or undefined in a browser. Not `isReactNativeApp()`: see AGENTS.md. */
export const getNativeBridge = (): INativeBridge | undefined => (window as any).ReactNativeWebView

/** Asks the app to open a legal page in the system browser, by name rather than URL. */
export const requestLegalLinkFromApp = (bridge: INativeBridge, link: LegalLink, countryCode?: string): void => {
    bridge.postMessage(JSON.stringify({ type: 'open_legal_link', link, country: countryCode }))
}
